<template>
  <div class="blocked_logs_page">
    <h1>签到数据</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <el-table
        :data="tableList"
        style="width: 100%"
        border
        v-loading="login1"
      >
       
        <el-table-column align="center" prop="date" label="日期"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="newUser" label="新增用户数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="dauUser" label="活跃用户数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="totalSignInUSer" label="总签到人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInOne" label="签到1天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInTwo" label="签到2天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInThree" label="签到3天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInFour" label="签到4天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInFive" label="签到5天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInSix" label="签到6天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInSeven" label="签到7天人数"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="signInSevenToFourteen" label="签到7-14天人数"  sortable width="140">
        </el-table-column>
        <el-table-column align="center" prop="signInMore" label="签到14天以上人数"  sortable width="150">
        </el-table-column>

        
      </el-table>
      <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data() {
    return {
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(2), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: -1,
      userTypes: [
        {
          label: 'total',
          value: -1
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 0
        }
      ],
      page: 1,
      total: 0
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_signIn,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType:this.userType,
          page: this.page
        }
      })
      if (res !== null) {
        this.tableList = res.data.data
        this.total = res.data.total
        this.login1 = false
      }
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 生成并下载主播excel
    async downloadReport() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_signIn_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          userType: this.userType
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(
        res.data,
        '签到数据' + (this.platformData[0] + '-' + this.platformData[1])
      )
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
